import request, { requestbody } from './request.js';

// 账套页面查询
export async function ywlxgz_query(params = {}) {
    return await requestbody('setOfBook/query', 'post', params);
}

// 业务规则页面查询
export async function ywgz_query(params = {}) {
    return await requestbody('bsRule/query', 'post', params);
}

// 新建账套添加企业查询
export async function addgs_quey(params = {}) {
    return await requestbody('sys/getCompanyListByCase', 'post', params)
}

// 查询当前业务专项下是否有默认账套
export async function addzt_cxmrzt(params = {}) {
    return await request('setOfBook/queryDefaultSetOfBooksBySpecial', 'post', params)
}

// 查询当前企业应用账套信息
export async function addzt_cxyyztxx(params = {}) {
    return await requestbody('setOfBook/querySetOfBooksCompanyByCompanyCode', 'post', params)
}

// 保存账套信息
export async function addzt_bcztxx(params = {}) {
    return await requestbody('setOfBook/saveSetOfBooksInfo', 'post', params)
}

// 查询账套下所有使用的企业
export async function addzt_cxsyqy(params = {}) {
    return await request('setOfBook/queryCompanySetOfBooks', 'post', params)
}

// 业务类型管理页面查询
export async function ywlxgl_query(params = {}) {
    return await requestbody('business/queryBusinessTypeList', 'post', params);
}

// 业务类型管理页面查询
export async function ywlxgltj_xzywlx(params = {}) {
    return await requestbody('business/saveOrUpdateBusiness', 'post', params);
}

// 业务类型规则等级查询
export async function ywlxgz_djxc(params = {}) {
    return await request('bsRule/getRuleLevelByBookId', 'post', params);
}

// 操作规则优先级
export async function ywlxgz_czyxj(params = {}) {
    return await requestbody('bsRule/operationLevel', 'post', params);
}

// 删除业务类型
export async function ywlxgz_scgz(params = {}) {
    return await requestbody('business/deleteBusiness', 'post', params);
}

// 查询所有除当前规则外的启用的规则
export async function ywlxgz_cxmr(params = {}) {
    return await requestbody('bsRule/getEnableRules', 'post', params);
}

// 删除业务规则
export async function ywlxgz_scywgz(params = {}) {
    return await requestbody('bsRule/deleteRule', 'post', params);
}

// 删除账套
export async function ywlxgz_sczt(params = {}) {
    return await requestbody('setOfBook/deleteSetOfBook', 'post', params);
}

// 查询业务类型
export async function ywlxgz_ywlxquery(params = {}) {
    return await requestbody('business/queryType', 'post', params);
}

// 查询对应的属性
export async function ywlxgz_cxdclf(params = {}) {
    return await request('bsRuleDetail/findFieldByType', 'post', params);
}

// 业务规则编辑数据查询
export async function ywlxgz_bjcx(params = {}) {
    return await request('bsRuleDetail/queryRulesInfoById', 'post', params);
}

// 保存或编辑业务规则
export async function ywlxgz_bcywgz(params = {}) {
    return await requestbody('bsRuleDetail/saveRule', 'post', params);
}